/* ################################################### */
/*          util         */
/* ################################################### */

import { ObjectUtil } from "@repo/libs/utils";

/* ################################################### */
/*          component          */
/* ################################################### */

import ComponentBase from "./c.base";

export default class ComponentBaseAbstract extends ComponentBase {
    /**
     * constructor
     *
     * @param {*} props
     */
    constructor(props) {
        super();
    }

    /**
     * navigate
     *
     * @param {*} route
     */
    navigate(route, param = {}) {
        if (this.props?.routeNavigate || false) {
            this.props.routeNavigate(route, param);
        }
    }

    /**
     * get navigate param
     *
     * @param {*} key
     */
    navigateParam(key) {
        return this.props?.routeNavigateParam?.param || null
            ? this.props?.routeNavigateParam?.param[key] || ""
            : "";
    }

    /**
     * navigate param exist
     *
     * @param {*} key
     */
    navigateParamExist(key) {
        return ObjectUtil.hasProperty(
            this.props.routeNavigateParam?.param || {},
            key
        );
    }

    /**
     * dispatch action
     *
     * @param {*} functionName
     */
    dispatchAction(functionName) {
        if (this.props?.dispatchAction || false) {
            this.props.dispatchAction({
                compId: this.uuid(),
                functionName: functionName
            });
        }
    }

    _onErrorPage(error, errorInfo) {
        console.log("ComponentBaseAbstract : _onReady : *** ", [
            error,
            errorInfo
        ]);
    }

    /**
     * deprecated
     */
    handleError(error) {}
}
